import { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';

export default function ReviewSlider({ reviews: initialReviews }) {
  const [reviews, setReviews] = useState(initialReviews || []);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  const touchStartX = useRef(null);

  const defaultReviews = [
    {
      name: 'Henriette Bläske',
      date_info: 'God pris',
      comment: 'Jeg har gået ved Tine til massage i lidt over et år nu, og er fornyligt begyndt ved Sophie til zoneterapi, og jeg må sige at begge behandlere er kompetente i deres arbejde, og jeg har kun god erfaring med dem begge. Jeg er især overrasket over effekten af zoneterapien, som har hjulpet med min søvn, spændinger i kroppen, samt bivirkninger af medicin.',
      rating: 5,
    },
    {
      name: 'Yvonne Jensen',
      date_info: 'God pris',
      comment: 'Vil klar anbefaler dette sted god massage og så har de også zoneterapi som også er en god oplevelse 😊',
      rating: 5,
    },
    {
      name: 'Kathrin Savace',
      date_info: 'Fantastisk resultat',
      comment: 'Tine er en fantastisk dygtig og rar massør. Hun hjalp mig af med en ond hold i nakken og ryg. Top professionel og dygtig massør - min varmeste og bedste anbefaling 🌟🌟🌟🌟🌟🌟❤️',
      rating: 5,
    },
    {
      name: 'Malene Adelsböll Nikolajsen',
      date_info: 'De bedste anbefalinger',
      comment: 'Kan helt klart anbefale at bruge Djurs Massage. Har både fået massage, kopper, nåle og ultralyd hos hende. Det er et besøg. De bedste anbefalinger herfra. ⭐️⭐️⭐️⭐️⭐️',
      rating: 5,
    },
  ];

  useEffect(() => {
    if (initialReviews && initialReviews.length > 0) {
      setReviews(initialReviews);
    } else {
      fetch('/_api/public/v2/content/anmeldelser')
        .then((r) => (r.ok ? r.json() : null))
        .then((data) => {
          if (data && data.items && data.items.length > 0) {
            const mapped = data.items
              .filter((item) => {
                const text = (item.anmeldelse || item.comment || '').toLowerCase();
                return !text.includes('h-jewelry') && !text.includes('smykk');
              })
              .map((item) => ({
              ...item,
              name: item.navn || item.name,
              comment: item.anmeldelse || item.comment,
              date_info: item.tidspunkt || item.date_info,
              rating: item.stjerner || item.rating || 5,
            }));
            setReviews(mapped);
          } else {
            setReviews(defaultReviews);
          }
        })
        .catch(() => setReviews(defaultReviews));
    }
  }, [initialReviews]);

  const items = reviews.length > 0 ? reviews : defaultReviews;
  const count = items.length;

  useEffect(() => {
    if (isPaused || count <= 1) return;
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % count);
    }, 5500);
    return () => clearInterval(interval);
  }, [isPaused, count]);

  const handlePrev = () => {
    setCurrentIndex((prev) => (prev - 1 + count) % count);
  };

  const handleNext = () => {
    setCurrentIndex((prev) => (prev + 1) % count);
  };

  const getItemAt = (offset) => items[(currentIndex + offset) % count];

  const handleTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
    setIsPaused(true);
  };

  const handleTouchEnd = (e) => {
    if (touchStartX.current === null) return;
    const diff = e.changedTouches[0].clientX - touchStartX.current;
    if (diff > 40) {
      handlePrev();
    } else if (diff < -40) {
      handleNext();
    }
    touchStartX.current = null;
    setIsPaused(false);
  };

  return (
    <div
      className="relative"
      onMouseEnter={() => setIsPaused(true)}
      onMouseLeave={() => setIsPaused(false)}
      onTouchStart={handleTouchStart}
      onTouchEnd={handleTouchEnd}
    >
      {/* Slider Header Bar - NO paragraph above heading */}
      <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-6">
        <div>
          <h2 className="text-2xl sm:text-3xl font-bold text-[#1E3A5F] font-serif">
            Hvad siger vores kunder?
          </h2>
        </div>

        <div className="flex items-center gap-3">
          <Link
            to="/anmeldelser#skriv-anmeldelse"
            className="inline-flex items-center gap-2 px-3 py-1.5 sm:px-4 sm:py-2 bg-[#1E3A5F] text-white text-xs font-semibold rounded-full hover:shadow-md transition-shadow"
          >
            <i className="fa-solid fa-pen-to-square text-[#C9A770]" aria-hidden="true" />
            <span>Skriv en anmeldelse</span>
          </Link>

          <div className="flex items-center gap-1">
            <button
              type="button"
              onClick={handlePrev}
              aria-label="Forrige anmeldelse"
              className="p-2 text-[#1E3A5F] hover:text-black transition-colors"
            >
              <i className="fa-solid fa-chevron-left text-base" aria-hidden="true" />
            </button>
            <button
              type="button"
              onClick={handleNext}
              aria-label="Næste anmeldelse"
              className="p-2 text-[#1E3A5F] hover:text-black transition-colors"
            >
              <i className="fa-solid fa-chevron-right text-base" aria-hidden="true" />
            </button>
          </div>
        </div>
      </div>

      {/* Infinite slider container */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {/* Card 1 */}
        <div className="group bg-white p-6 border border-[#E8E1D5] hover:shadow-lg transition-shadow flex flex-col justify-between">
          <div>
            <div className="flex items-center justify-between mb-3">
              <div className="flex items-center gap-1 text-[#C9A770]">
                {[...Array(getItemAt(0)?.rating || 5)].map((_, i) => (
                  <i key={i} className="fa-solid fa-star text-xs" aria-hidden="true" />
                ))}
              </div>
              <i className="fa-solid fa-quote-right text-slate-300 text-lg" aria-hidden="true" />
            </div>
            <p className="text-slate-700 group-hover:text-black transition-colors text-sm leading-relaxed italic mb-5">
              "{getItemAt(0)?.comment}"
            </p>
          </div>
          <div className="pt-3 border-t border-[#F2ECE3] flex items-center justify-between text-xs">
            <div className="font-bold text-[#1E3A5F] group-hover:text-black transition-colors">{getItemAt(0)?.name}</div>
            {getItemAt(0)?.date_info && (
              <span className="text-slate-400">{getItemAt(0)?.date_info}</span>
            )}
          </div>
        </div>

        {/* Card 2 */}
        <div className="hidden md:flex group bg-white p-6 border border-[#E8E1D5] hover:shadow-lg transition-shadow flex-col justify-between">
          <div>
            <div className="flex items-center justify-between mb-3">
              <div className="flex items-center gap-1 text-[#C9A770]">
                {[...Array(getItemAt(1)?.rating || 5)].map((_, i) => (
                  <i key={i} className="fa-solid fa-star text-xs" aria-hidden="true" />
                ))}
              </div>
              <i className="fa-solid fa-quote-right text-slate-300 text-lg" aria-hidden="true" />
            </div>
            <p className="text-slate-700 group-hover:text-black transition-colors text-sm leading-relaxed italic mb-5">
              "{getItemAt(1)?.comment}"
            </p>
          </div>
          <div className="pt-3 border-t border-[#F2ECE3] flex items-center justify-between text-xs">
            <div className="font-bold text-[#1E3A5F] group-hover:text-black transition-colors">{getItemAt(1)?.name}</div>
            {getItemAt(1)?.date_info && (
              <span className="text-slate-400">{getItemAt(1)?.date_info}</span>
            )}
          </div>
        </div>

        {/* Card 3 */}
        <div className="hidden lg:flex group bg-white p-6 border border-[#E8E1D5] hover:shadow-lg transition-shadow flex-col justify-between">
          <div>
            <div className="flex items-center justify-between mb-3">
              <div className="flex items-center gap-1 text-[#C9A770]">
                {[...Array(getItemAt(2)?.rating || 5)].map((_, i) => (
                  <i key={i} className="fa-solid fa-star text-xs" aria-hidden="true" />
                ))}
              </div>
              <i className="fa-solid fa-quote-right text-slate-300 text-lg" aria-hidden="true" />
            </div>
            <p className="text-slate-700 group-hover:text-black transition-colors text-sm leading-relaxed italic mb-5">
              "{getItemAt(2)?.comment}"
            </p>
          </div>
          <div className="pt-3 border-t border-[#F2ECE3] flex items-center justify-between text-xs">
            <div className="font-bold text-[#1E3A5F] group-hover:text-black transition-colors">{getItemAt(2)?.name}</div>
            {getItemAt(2)?.date_info && (
              <span className="text-slate-400">{getItemAt(2)?.date_info}</span>
            )}
          </div>
        </div>
      </div>

      {/* Pagination indicators */}
      <div className="flex items-center justify-center gap-1.5 mt-6">
        {items.map((_, idx) => (
          <button
            key={idx}
            type="button"
            onClick={() => setCurrentIndex(idx)}
            aria-label={`Gå til anmeldelse ${idx + 1}`}
            className={`h-1.5 transition-all ${
              idx === currentIndex ? 'w-5 bg-[#1E3A5F]' : 'w-2 bg-[#D8CDBE]'
            }`}
          />
        ))}
      </div>
    </div>
  );
}
